export default __webpack_public_path__ + "static/media/scrollcard5.db478b1f.jpg";